import * as React from 'react';
import { Tag, PriceTag } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const classPrefix = 'upsell-item-product';
const Product = ({ body , price , title , imageUrl , tag  })=>/*#__PURE__*/ React.createElement("div", {
        className: `${classPrefix}`
    }, /*#__PURE__*/ React.createElement("div", {
        className: `${classPrefix}__header`
    }, tag && /*#__PURE__*/ React.createElement(Tag, {
        iconKey: tag.key,
        label: tag.value
    })), /*#__PURE__*/ React.createElement("div", {
        className: `${classPrefix}__image-container`
    }, /*#__PURE__*/ React.createElement("img", {
        className: `${classPrefix}__image`,
        src: `${imageUrl}?w=300&auto=format`,
        alt: title
    })), /*#__PURE__*/ React.createElement(Text, {
        className: `${classPrefix}__title`,
        variant: "body-head"
    }, title), body && /*#__PURE__*/ React.createElement(Text, {
        className: `${classPrefix}__subtitle`,
        variant: "caption"
    }, body), /*#__PURE__*/ React.createElement(PriceTag, {
        className: `${classPrefix}__price`,
        originalPrice: price.originalPrice,
        discountedPrice: price.discountedPrice,
        currency: price.currency
    }))
;

export { Product };
//# sourceMappingURL=Product.js.map
